export default "<ui-view></ui-view>";